import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const StatsContainer = ({ mediaType, visibleItems, statusOptions }) => {
  const getColorForIndex = (i) => {
    const defaultColors = ['#4c6aaf', '#dbe5fd', '#cccccc', '#ff5555', '#b4f8c8', '#ffb5e8', '#fdfd96'];
    return defaultColors[i % defaultColors.length];
  };

  const data = {
    labels: statusOptions,
    datasets: [{
      data: statusOptions.map(status => visibleItems.filter(item => item.status === status).length),
      backgroundColor: statusOptions.map((_, i) => getColorForIndex(i)),
    }],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%',
    plugins: {
      legend: { position: 'bottom' },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.raw}`,
        },
      },
    },
  };

  const plugins = [{
    id: 'totalCenterText',
    afterDraw(chart) {
      const { width, height, ctx } = chart;
      ctx.restore();
      const total = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
      ctx.font = 'bold 25px Arial';
      ctx.fillStyle = '#fff';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(total, width / 2, height / 3);
      ctx.save();
    },
  }];

  return (
    <div className="stats-container desktop-only">
      <h3>Stats</h3>
      {mediaType === 'SteamGame' && (
        <p>Total Achievements: <span id="stat-achievements">
          {visibleItems.reduce((sum, item) => sum + (item.achievements_unlocked || 0), 0)}
        </span></p>
      )}
      {/* <Doughnut data={data} options={options} plugins={plugins} /> */}
    </div>
  );
};

export default StatsContainer;